import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { BidService } from 'src/app/shared/services/bid.service';
import { TableColumn, TableAction } from 'src/app/shared/components/data-table/data-table.component';

@Component({
  selector: 'app-bids',
  templateUrl: './bids.component.html',
  styleUrls: ['./bids.component.scss']
})
export class BidsComponent implements OnInit {
  AppConstants = AppConstants;
  bids: any[] = [];
  tableColumns: TableColumn[] = [];
  selectedBids: any[] = [];

  constructor(
    private _loaderService: LoaderService,
    private _bidService: BidService,
    private _router: Router,
    private _cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.initializeTableColumns();
    this.fetchBids();
  }

  private initializeTableColumns(): void {
    const actionIcons: TableAction[] = [
      {
        iconPath: 'assets/icons/eye-icon.svg',
        action: 'view',
        title: 'View'
      },
      // {
      //   iconPath: 'assets/icons/edit-check.svg',
      //   action: 'document',
      //   title: 'Document'
      // },
      // {
      //   iconPath: 'assets/icons/user-check-icon.svg',
      //   action: 'award',
      //   title: 'Award'
      // },
      // {
      //   iconPath: 'assets/icons/close-icon.svg',
      //   action: 'delete',
      //   title: 'Delete'
      // }
    ];

    this.tableColumns = [
      {
        field: 'bidId',
        header: 'Bid ID',
        type: 'text'
      },
      {
        field: 'tenderId',
        header: 'Tender ID',
        type: 'link'
      },
      {
        field: 'vendor',
        header: 'Vendor',
        type: 'text'
      },
      {
        field: 'submissionDeadline',
        header: 'Submission Deadline',
        type: 'date',
        format: 'dd-MM-yyyy'
      },
      {
        field: 'status',
        header: 'Status',
        type: 'badge',
        badgeClass: 'status-badge'
      },
      {
        field: 'tcCommitteeStatus',
        header: 'Committee Status',
        type: 'badge',
        badgeClass: 'status-badge'
      },
      // {
      //   field: 'evaluationType',
      //   header: 'Evaluation Type',
      //   type: 'badge',
      //   badgeClass: 'evaluation-type-badge'
      // },
      {
        field: 'actions',
        header: 'Actions',
        type: 'action',
        sortable: false,
        actions: actionIcons
      }
    ];
  }

  async fetchBids(): Promise<void> {
    this._loaderService.showLoader();
    try {
      // Call the API to get all bids
      const response = await this._bidService.getAllBids(true);
      
      if (response.isSuccess && response.data) {
        // Map API response to component format - create new array reference
        this.bids = response.data.map(bidItem => 
          this._bidService.mapBidItemToComponentFormat(bidItem)
        );
        this.bids = [...this.bids];
      } else {
        console.error('Failed to fetch bids:', response.errorMessageEn || response.errorMessageAr);
        this.bids = [];
      }
    } catch (error) {
      console.error('Failed to fetch bids:', error);
      this.bids = [];
    } finally {
      this._loaderService.hideLoader();
      // Trigger change detection to update the view
      this._cdr.detectChanges();
    }
  }

  uploadBids(): void {
    // TODO: Implement upload functionality
    console.log('Upload Bids');
  }

  openUnsealingDocuments(): void {
    // TODO: Implement unsealing documents functionality
    console.log('Open Unsealing Documents');
  }

  onTableActionClick(event: { action: string, row: any }): void {
    if (event.row?.isBidLocked) {
      return;
    }

    switch (event.action) {
      case 'view':
        this.viewBid(event.row.bidId, event.row.tenderId, event.row.vendorId);
        break;
      case 'document':
        this.viewDocuments(event.row.bidId);
        break;
      case 'award':
        this.awardBid(event.row.bidId);
        break;
      case 'delete':
        this.deleteBid(event.row.bidId);
        break;
    }
  }

  onTableLinkClick(event: { field: string, row: any }): void {
    if (event.row?.isBidLocked) {
      return;
    }

    if (event.field === 'tenderId') {
      this.viewTender(event.row.tenderId);
    }
  }

  viewBid(bidId: string, tenderId?: string, vendorId?: string): void {
    if (tenderId) {
      this._router.navigate([`/${AppConstants.ROUTES.BID}/${AppConstants.ROUTES.BIDDETAILS}/${bidId}`], {
        queryParams: { tenderId: tenderId, vendorId: vendorId || null }
      });
    } else {
      // Find tenderId from the bids array
      const bid = this.bids.find(b => b.bidId === bidId);
      if (bid && bid.tenderId) {
        this._router.navigate([`/${AppConstants.ROUTES.BID}/${AppConstants.ROUTES.BIDDETAILS}/${bidId}`], {
          queryParams: { tenderId: bid.tenderId, vendorId: bid.vendorId || null }
        });
      } else {
        this._router.navigate([`/${AppConstants.ROUTES.BID}/${AppConstants.ROUTES.BIDDETAILS}/${bidId}`]);
      }
    }
  }

  viewTender(tenderId: string): void {
    this._router.navigate([`/${AppConstants.ROUTES.TENDER}/${AppConstants.ROUTES.TENDERDETAILS}/${tenderId}`]);
  }

  viewDocuments(bidId: string): void {
    // TODO: Open documents dialog
    console.log('View Documents:', bidId);
  }

  awardBid(bidId: string): void {
    // TODO: Implement award bid functionality
    console.log('Award Bid:', bidId);
  }

  deleteBid(bidId: string): void {
    // TODO: Implement delete bid functionality
    console.log('Delete Bid:', bidId);
  }

  onCheckboxChange(event: { row: any, checked: boolean }): void {
    if (event.row?.isBidLocked) {
      this.selectedBids = this.selectedBids.filter(bid => bid.bidId !== event.row.bidId);
      return;
    }

    if (event.checked) {
      const exists = this.selectedBids.some(bid => bid.bidId === event.row.bidId);
      if (!exists) {
        this.selectedBids = [...this.selectedBids, event.row];
      }
    } else {
      this.selectedBids = this.selectedBids.filter(bid => bid.bidId !== event.row.bidId);
    }
  }

  get selectedBidsText(): string {
    const count = this.selectedBids.length;
    return `${count} bid${count !== 1 ? 's' : ''} selected`;
  }

  handleBulkAction(action: 'assign' | 'award' | 'regret'): void {
    if (this.selectedBids.length === 0) return;
    const actionMap = {
      assign: 'Assign Evaluation',
      award: 'Award Selected',
      regret: 'Regret Selected'
    };
    console.log(`${actionMap[action]} to:`, this.selectedBids);
    // TODO: Implement bulk action functionality
  }
}

